import { defineComponent, PropType, reactive, ref } from 'vue';
import { useStore } from 'vuex';
import { ProjectAction } from '@/store/project/project.module';
import { FiscalYear } from '@/store/fiscalYear/fiscalYear.model';
import { Province } from '@/store/province/province.model';
import { ProjectForm, BudgetForm, ApprovementForm } from '@/store/project/project.model';
import { ProjectResultAction } from '@/store/projectResult/projectResult.module';
import ProjectTabComponent from './projectTab/ProjectTab.vue';
import BudgetTabComponent from './budgetTab/BudgetTab.vue';
import ApprovementTabComponent from './approvementTab/ApprovementTab.vue';

export default defineComponent({
  name: 'CreateProjectWizardComponent',
  components: {
    ProjectTabComponent,
    BudgetTabComponent,
    ApprovementTabComponent,
  },
  emits: [
    'toggle',
  ],
  props: {
    fiscalYear: {
      type: Object as PropType<FiscalYear>,
      required: true,
    },
    province: {
      type: Object as PropType<Province>,
      required: true,
    },
  },
  setup: (props, context) => {
    const store = useStore();
    const navigator = reactive({
      items: 3,
      percent: 0,
      current: 0,
      done: 0
    });

    const project = reactive<ProjectForm>({
      name: '',
      description: null,
      projectTypeId: null,
      fiscalYearId: props.fiscalYear?.id,
      provinceId: props.province?.id,
    });
    const budgets = ref<BudgetForm[]>([]);
    const approvement = reactive<ApprovementForm>({
      fiscalYearId: props.fiscalYear?.id,
      cabinetMinisterId: null,
      approvedDate: null,
    });

    const backClick = () => {
      context.emit('toggle');
    };

    const selectClick = (index: number) => {
      navigator.percent = index * 100 / (navigator.items - 1);
      navigator.current = index;
    };

    const nextStep = (index: number) => {
      navigator.percent = index * 100 / (navigator.items - 1);
      navigator.current = index;
      navigator.done = index;
    };

    const toBudget = (projectData: ProjectForm) => {
      project.name = projectData.name,
      project.description = projectData.description,
      project.projectTypeId = projectData.projectTypeId,
      nextStep(1);
    };

    const toApprovement = (budgetData: BudgetForm[]) => {
      budgets.value = [];
      budgetData.forEach(m => budgets.value.push(m));
      nextStep(2);
    };

    const toSubmit = (approvementForm: ApprovementForm) => {
      approvement.cabinetMinisterId = approvementForm.cabinetMinisterId;
      approvement.approvedDate = approvementForm.approvedDate;
      save();
    };

    const save = () => {
      store.dispatch(ProjectAction.CREATE, {
        ...project,
        projectBudgets: budgets.value.map(m => {
          return { budgetTypeId: m.budgetTypeId, amount: m.amount };
        }),
        projectApprovement: approvement,
      })
        .then(() => store.dispatch(ProjectResultAction.UPDATE_REGION_RESULT, {
          id: project.provinceId,
          budget: budgets.value.filter(m => m.budgetTypeId === 1|| m.budgetTypeId === 2 || m.budgetTypeId === 5).reduce((total, m) => total + (m.amount ? m.amount : 0), 0),
          residual: 0,
        }))
          .then(() => context.emit('toggle'));
    };

    return {
      project,
      budgets,
      approvement,
      navigator,
      backClick,
      selectClick,
      toBudget,
      toApprovement,
      toSubmit,
    };
  },
});
